import React, { useEffect, useState } from "react";
import { SignalDirectionType, SignalsMap } from "predictagram-lib";
import { DropDown } from "../../common/form/DropDown";
import { AnalysisFilters } from "../../common/analysis/analysis.filters";
import { StrategyProfitModel } from "../../../models/strategy-profit.model";
import { TradeModel } from "models/trade.model";

const toIntOrDefault = (v: any, def = null) => {
  return v !== '' ? parseInt(v, 10) : def;
}

interface IProps {
  setupName: string,
  errors: any,
  touched: any,
  setFieldValue: any,
  initialSignalSelected?: boolean,
  onOpenSignalDirection?: (direction: "up" | "dn") => void,
}

export const SignalSetupComp: React.FunctionComponent<IProps> = ({ setupName, errors, touched, setFieldValue, initialSignalSelected=false, onOpenSignalDirection }) => {
  const signalsList = new Map(SignalsMap);
  const [signalSelected, setSignalSelected] = useState<boolean>(initialSignalSelected);

  useEffect(()=>{
    setSignalSelected(initialSignalSelected);
  }, [initialSignalSelected])

  const signalRepeatIntervalSecs = AnalysisFilters.SignalRepeatTypes;

  //const oppositeDirRef = useRef(false);
  return (
    <div className="border p-3">
      <DropDown enumMap={signalsList} defaultItem={{ key: '', value: 'None' } as any} onChange={(v: any) => { setSignalSelected(v.target.value !== ''); setFieldValue(`${setupName}[type]`, v.target.value) }} errors={errors} touched={touched} label="Signal" name={`${setupName}[type]`} />
      {signalSelected && <>
        <DropDown enumMap={signalRepeatIntervalSecs} errors={errors} touched={touched} onChange={(v: any) => { setFieldValue(`${setupName}[repeatSecs]`, toIntOrDefault(v.target.value)) }} label="Repeat Time" name={`${setupName}[repeatSecs]`} />
        <DropDown enumMap={TradeModel.oppositeDir as any} errors={errors} touched={touched} onChange={(v: any) => { setFieldValue(`${setupName}[oppositeDirection]`, parseInt(v.target.value)) }} label="Opposite Direction" name={`${setupName}[oppositeDirection]`} />
        <DropDown enumMap={TradeModel.signalRepeatType} multiple={true} errors={errors} touched={touched} label="Repeat Types" name={`${setupName}[repeatTypes]`} onChange={(v: any) => { setFieldValue(`${setupName}[repeatTypes]`, StrategyProfitModel.toIntArrayOrDefault(Array.from(v.target.selectedOptions).map((o: any) => o.value))); }} />
        <DropDown enumMap={TradeModel.signalDirectionType} multiple={true} errors={errors} touched={touched} label="Direction Types" name={`${setupName}[directionTypes]`} onChange={(v: any) => { 
          const selectedDirectionTypes = StrategyProfitModel.toIntArrayOrDefault(Array.from(v.target.selectedOptions).map((o: any) => o.value));
          setFieldValue(`${setupName}[directionTypes]`, selectedDirectionTypes);
          if (onOpenSignalDirection) {
            onOpenSignalDirection(selectedDirectionTypes[0] === SignalDirectionType.DOWN ? "dn" : "up");
          }
          }} />
        <DropDown enumMap={signalRepeatIntervalSecs} errors={errors} touched={touched} onChange={(v: any) => { setFieldValue(`${setupName}[cancellationSecs]`, toIntOrDefault(v.target.value)) }} label="Cancellation Time" name={`${setupName}[cancellationSecs]`} />
      </>}
      {/*<label>*/}
      {/*  <input type="checkbox" onChange={() => {oppositeDirRef.current=!oppositeDirRef.current;}} />*/}
      {/*  <span className="ms-1">{'Opposite Direction'}</span>*/}
      {/*</label>*/}
    </div>
  )
}






